import React, { useContext, useState } from "react";
import { Card, Link, Collapsible, Caption, Layout, Stack, Heading, TextStyle } from "@shopify/polaris";

import { withErrorBoundary } from "lib/hoc";

// import helper
import { baseHelper } from "lib/helpers";

import { SkeletonAnnotatedCard } from "lib/components";
import { PrivateContext } from "lib/context";
import standardList from "./standardConfig";

const OperatorAnalytics = () => {
  const [openSetup, setOpenSetup] = useState({});
  const { cms, currentUser, isLoading } = useContext(PrivateContext);

  const handleSetupToggle = (key) => {
    setOpenSetup((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const borderSet = {
    border: "0",
  };

  const iconHeightFix = {
    lineHeight: "2.2em",
  };
  const hiddenCards = ["Billing", "General"];

  if (isLoading) {
    return <SkeletonAnnotatedCard />;
  }

  return (standardList(cms) || []).map((analyticList) => {
    const updateAnalyticList = analyticList.list;
    return (
      <Layout.AnnotatedSection
        title="Analytics"
        description={[
          <div>
            <TextStyle variation="subdued">{analyticList.description}</TextStyle>
          </div>,
        ]}
      >
        {updateAnalyticList.map((actionList) => {
          const actionData = actionList.actions;
          return (
            !hiddenCards.includes(actionList.title) && (
              <Card>
                <Card.Header
                  sectioned
                  title={
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <Stack>
                      <i className={actionList.icon} style={iconHeightFix} />
                      <Heading>
                        {actionList.title}
                        <TextStyle variation="subdued">
                          <Caption>{actionList.description}</Caption>
                        </TextStyle>
                      </Heading>
                    </Stack>
                  }
                  actions={[
                    {
                      content: openSetup[actionList.code] ? "Hide" : "Show",
                      onAction: () => handleSetupToggle(actionList.code),
                      disclosure: openSetup[actionList.code] ? "up" : "down",
                    },
                  ]}
                />
                <br />

                <Collapsible open={openSetup[actionList.code]} id={`collapsible${actionList.code}`}>
                  <Card.Section subdued>
                    {actionData.map((step) => {
                      return (
                        <div style={borderSet}>
                          <Card.Section subdued>
                            <Stack>
                              <Stack.Item>
                                <Link url={step.link}>{step.label}</Link>
                                <TextStyle variation="">
                                  <Caption>{step.description}</Caption>
                                </TextStyle>
                              </Stack.Item>
                            </Stack>
                          </Card.Section>
                        </div>
                      );
                    })}
                  </Card.Section>
                </Collapsible>
              </Card>
            )
          );
        })}
      </Layout.AnnotatedSection>
    );
  });
};

export default withErrorBoundary(OperatorAnalytics);
